import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { message, Modal, Spin, Tabs } from 'antd';
import PropTypes from 'prop-types';
import { commissionBracketsType } from '../../constants/global';
import {
	getactionMessages,
	getClientMessages,
	getCommissionMessages,
	getErrorMessages,
	getModalMessages,
	getRoleMessages,
} from '../../constants/messages';
import {
	LoadCommissionAnnualPercent,
	LoadCommissionBrackets,
	LoadCommissionProductInfo,
	LoadCommissionProductsConfig,
	LoadCommissionSalesPercent,
} from './actions';
import AnnualConfigurations from './AnnualConfigurations';
import LeasedConfigurations from './LeasedConfigurations';
import SaleConfigurations from './SaleConfigurations';

let commissionMessages = getCommissionMessages(),
	actionMessages = getactionMessages(),
	modalMessages = getModalMessages(),
	errorMessages = getErrorMessages(),
	clientMessages = getClientMessages(),
	roleMessages = getRoleMessages();

const messages = {
	...commissionMessages,
	...actionMessages,
	...modalMessages,
	...errorMessages,
	...clientMessages,
	...roleMessages,
};

const ConfigModal = ({ showModal, handleCancel }) => {
	const intl = useIntl();
	const [isLoading, setIsLoading] = useState(false);
	const [commissionAnnualPercent, setCommissionAnnualPercent] = useState({});
	const [commissionSalesPercent, setCommissionSalesPercent] = useState({});
	const [products, setProducts] = useState([]);
	const [productsSales, setProductsSales] = useState({});
	const [productsAnnual, setProductsAnnual] = useState({});
	const [productsLeased, setProductsLeased] = useState({});
	const [customPriceProductsLeased, setCustomPriceProductsLeased] = useState({});
	const [customPriceProductsSales, setCustomPriceProductsSales] = useState({});
	const [commissionLeasedBrackets, setCommissionLeasedBrackets] = useState([]);
	const [commissionSalesBrackets, setCommissionSalesBrackets] = useState([]);

	useEffect(() => {
		const fetchData = async () => {
			try {
				setIsLoading(true);
				const annualPercent = await LoadCommissionAnnualPercent();
				const salesPercent = await LoadCommissionSalesPercent();
				const products = await LoadCommissionProductInfo();
				const commissionLeasedBrackets = await LoadCommissionBrackets(commissionBracketsType.LEASED);
				const commissionSalesBrackets = await LoadCommissionBrackets(commissionBracketsType.SALES);
				const productsLeased = await LoadCommissionProductsConfig('COMMISSION_PRODUCTS_LEASED');
				const productsSales = await LoadCommissionProductsConfig('COMMISSION_PRODUCTS_SALED');
				const productsAnnual = await LoadCommissionProductsConfig('COMMISSION_PRODUCTS_ANNUAL');
				const customPriceProductsLeased = await LoadCommissionProductsConfig(
					'COMMISSION_CUSTOM_PRICE_PRODUCTS_LEASED'
				);
				const customPriceProductsSales = await LoadCommissionProductsConfig(
					'COMMISSION_CUSTOM_PRICE_PRODUCTS_SALED'
				);
				setCommissionAnnualPercent(annualPercent);
				setCommissionSalesPercent(salesPercent);
				setProducts(products);
				setCommissionLeasedBrackets(commissionLeasedBrackets);
				setCommissionSalesBrackets(commissionSalesBrackets);
				setProductsLeased(productsLeased);
				setProductsSales(productsSales);
				setProductsAnnual(productsAnnual);
				setCustomPriceProductsLeased(customPriceProductsLeased);
				setCustomPriceProductsSales(customPriceProductsSales);
			} catch (error) {
				message.error(intl.formatMessage({ ...messages.commonError }));
			} finally {
				setIsLoading(false);
			}
		};
		if (showModal) {
			fetchData();
		}
	}, [showModal]);

	const onCancel = () => {
		setIsLoading(false);
		handleCancel();
	};

	return (
		<Modal
			open={showModal}
			title={intl.formatMessage({ ...messages.commissionConfigurations })}
			onCancel={onCancel}
			destroyOnClose={true}
			footer={null}
		>
			<Spin spinning={isLoading}>
				<Tabs
					defaultActiveKey="1"
					items={[
						{
							label: intl.formatMessage({ ...messages.leased }),
							key: '1',
							children: (
								<LeasedConfigurations
									products={products}
									productsLeased={productsLeased}
									commissionBrackets={commissionLeasedBrackets}
									setCommissionBrackets={setCommissionLeasedBrackets}
									customPriceProductsLeased={customPriceProductsLeased}
								/>
							),
						},
						{
							label: intl.formatMessage({ ...messages.Sales }),
							key: '2',
							children: (
								<SaleConfigurations
									products={products}
									productsSales={productsSales}
									commissionBrackets={commissionSalesBrackets}
									setCommissionBrackets={setCommissionSalesBrackets}
									commissionPercent={commissionSalesPercent}
									customPriceProductsSales={customPriceProductsSales}
								/>
							),
						},
						{
							label: intl.formatMessage({ ...messages.commissionAnnual }),
							key: '3',
							children: (
								<AnnualConfigurations
									products={products}
									productsAnnual={productsAnnual}
									commissionPercent={commissionAnnualPercent}
								/>
							),
						},
					]}
				/>
			</Spin>
		</Modal>
	);
};

ConfigModal.propTypes = {
	showModal: PropTypes.bool.isRequired,
	handleCancel: PropTypes.func.isRequired,
};

export default ConfigModal;
